const LOGIN_PATH = '/login';
const FORGOT_PASSWORD_PATH = '/forgot-pass';
const RECOVER_PASSWORD_PATH = '/recover-pass';
const ACCOUNT_PATH = '/account';
const ACCOUNT_PATH_ADD = `${ACCOUNT_PATH}/add`;
const ACCOUNT_PATH_EDIT = `${ACCOUNT_PATH}/edit`;
const LOGIN_HISTORY_PATH = '/login-history';
const STATISTIC_HISTORY_PATH = '/statistic-login-history';

const EMAILCONFIG_PATH = '/emailconfig';
const EMAILCONFIG_CREATE_PATH = '/emailconfig/create';
const EMAILCONFIG_EDIT_PATH = '/emailconfig/edit';

const LOG_PATH = '/log';

const REPORT_POST_PATH = '/report-post';
const REPORT_POST_SYNTHETIC_PATH = '/report-post-synthentic';
const REPORT_POST_EXCEL_PATH = '/report-post-excel';
const REPORT_POST_EXCEL_QUANTITY_CREATE_BY =
    '/report-post-excel-quantity-createby';
const REPORT_POST_EXCEL_CREATE_BY = '/report-post-excel-createby';

const REPORT_POST_WEBANALYSIS_PATH = '/report-post-web-analysis';
const REPORT_POST_BY_DATETYPE = '/report-post-by-datetype';
const REPORT_POST_VIEW_DETAIL = '/report-post-view-detail';
const REPORT_POST_PUBLISHTIME_DATATYPE_PATH =
    '/report-post-publish-time-data-type';
const REPORT_ADVERTISING_ANALYSIS_PATH = '/advertising-analysis';
const REPORT_COUNT_VISIT_DETAIL = '/report-count-visit-detail';

const DONVI_PATH = '/don-vi';
const DONVI_CREATE_PATH = `${DONVI_PATH}/them`;
const DONVI_EDIT_PATH = `${DONVI_PATH}/sua`;

const DISEASE_PATH = '/benh';
const DISEASE_CREATE_PATH = `${DISEASE_PATH}/them`;
const DISEASE_EDIT_PATH = `${DISEASE_PATH}/sua`;
const DISEASE_ADD_PATIENT_PATH = `${DISEASE_PATH}/them-benh-nhan`;

const EXERCISE_PATH = '/bai-tap';
const EXERCISE_CREATE_PATH = `${EXERCISE_PATH}/them`;
const EXERCISE_EDIT_PATH = `${EXERCISE_PATH}/sua`;
const EXERCISE_DETAIL_PATH = `${EXERCISE_PATH}/chi-tiet`;

const PATIENTEXERCISE_PATH = '/bac-si-theo-doi';
const PATIENTEXERCISE_CHOSEN_PATH = '/benh-nhan-chon-bai';
const PATIENTEXERCISE_DETAIL_PATH = `${PATIENTEXERCISE_PATH}/chi-tiet`;

const SELECTEXERCISE_PATH = '/chon-bai-tap';
const SELECTDOCTOR_PATH = '/chon-bac-si';
const PATIENTPRACTICE_PATH = '/xem-va-tap';
const ACCOUNTPATIENT_PATH = '/quan-ly-benh-nhan';

export const URI_INTERNAL = {
    REPORT_ADVERTISING_ANALYSIS_PATH,
    REPORT_POST_VIEW_DETAIL,
    REPORT_POST_BY_DATETYPE,
    REPORT_POST_EXCEL_CREATE_BY,
    REPORT_POST_EXCEL_QUANTITY_CREATE_BY,
    REPORT_POST_SYNTHETIC_PATH,
    REPORT_POST_PATH,
    RECOVER_PASSWORD_PATH,
    FORGOT_PASSWORD_PATH,
    ACCOUNT_PATH_EDIT,
    ACCOUNT_PATH_ADD,
    LOGIN_PATH,
    ACCOUNT_PATH,
    LOGIN_HISTORY_PATH,
    EMAILCONFIG_PATH,
    EMAILCONFIG_CREATE_PATH,
    EMAILCONFIG_EDIT_PATH,
    STATISTIC_HISTORY_PATH,
    LOG_PATH,
    REPORT_POST_EXCEL_PATH,
    REPORT_POST_WEBANALYSIS_PATH,
    REPORT_POST_PUBLISHTIME_DATATYPE_PATH,
    REPORT_COUNT_VISIT_DETAIL,

    DONVI_PATH,
    DONVI_CREATE_PATH,
    DONVI_EDIT_PATH,

    DISEASE_PATH,
    DISEASE_CREATE_PATH,
    DISEASE_EDIT_PATH,
    DISEASE_ADD_PATIENT_PATH,

    EXERCISE_PATH,
    EXERCISE_CREATE_PATH,
    EXERCISE_EDIT_PATH,
    EXERCISE_DETAIL_PATH,

    PATIENTEXERCISE_PATH,
    PATIENTEXERCISE_DETAIL_PATH,
    PATIENTEXERCISE_CHOSEN_PATH,

    SELECTEXERCISE_PATH,
    SELECTDOCTOR_PATH,
    PATIENTPRACTICE_PATH,
    ACCOUNTPATIENT_PATH
};
